import { z } from "zod";
export * from "./stripe";

export {
  navigationBridgeEvent,
  HostNavigationStateSchema,
  HostNavigationCommandSchema,
  type HostNavigationState,
  type HostNavigationCommand,
} from "./navigation";

export const authBridgeEvent = "froppio:auth";

export const AuthUserSchema = z.object({
  id: z.string().min(1),
  email: z.string().optional(),
});

export const AuthSessionSchema = z.object({
  user: AuthUserSchema,
});

export type AuthUser = z.infer<typeof AuthUserSchema>;
export type AuthSession = z.infer<typeof AuthSessionSchema>;

const envelope = {
  channel: z.literal(authBridgeEvent),
  version: z.literal(1),
};

export const HostAuthRequestSchema = z.discriminatedUnion("operation", [
  z.object({ ...envelope, id: z.string().min(1), operation: z.literal("getSession") }),
  z.object({
    ...envelope,
    id: z.string().min(1),
    operation: z.literal("getAccessToken"),
    userId: z.string().min(1),
  }),
  z.object({ ...envelope, id: z.string().min(1), operation: z.literal("logout") }),
]);

const snapshot = {
  session: AuthSessionSchema.nullable(),
  revision: z.number().int().nonnegative(),
};

export const HostAuthMessageSchema = z.discriminatedUnion("type", [
  z.object({
    ...envelope,
    type: z.literal("response"),
    id: z.string().min(1),
    ...snapshot,
    accessToken: z.string().min(1).optional(),
  }),
  z.object({
    ...envelope,
    type: z.literal("error"),
    id: z.string().min(1),
    message: z.string().min(1),
  }),
  z.object({ ...envelope, type: z.literal("changed"), ...snapshot }),
]);

export type HostAuthRequest = z.infer<typeof HostAuthRequestSchema>;
export type HostAuthMessage = z.infer<typeof HostAuthMessageSchema>;
export type HostAuthResponse = Extract<HostAuthMessage, { type: "response" }>;
